import { keyframes } from "@emotion/core";
import styled from "@emotion/styled/macro";
import React from "react";

import tapIcon from "../../res/img_hint_tap.svg";

const pulse = keyframes`
  from, to {
    opacity: 0;
    transform: scale(1);
  }

  50% {
    opacity: 0;
    transform: scale(1);
  }

  60% {
    opacity: 1;
    transform: scale(1);
  }

  70% {
    opacity: 1;
    transform: scale(0.8);
  }

  80% {
    opacity: 1;
    transform: scale(1);
  }
`;

const TapHint = styled("i")`
  width: 8.6645%;
  background: url(${tapIcon}) no-repeat center center;
  background-size: contain;
  display: block;
  position: absolute;
  top: 47%;
  left: 40%;
  animation: ${pulse} 3s ease infinite;
  opacity: 1;
  transform: scale(1);

  &:after {
    content: "";
    display: block;
    padding-bottom: 116.667%;
  }
`;

export default function TapToBobbleHeadHint() {
  return <TapHint />;
}
